/** 仕入先共有: 「本日発送」判定（表示備考 + 依頼書発行日が今日）。 */

import { formatDateYmdInJst } from '../../utils/formatDateTime';

export const TODAY_SHIP_BIKO_SUBSTRING = '本日発送';

/**
 * 表示備考に「本日発送」が含まれるか（部分一致）。
 * @param {string|null|undefined} biko
 */
export function bikoContainsTodayShip(biko) {
  return typeof biko === 'string' && biko.includes(TODAY_SHIP_BIKO_SUBSTRING);
}

/**
 * 発行日時・日付から JST の YYYY-MM-DD を取り出す。
 * 日付のみ（YYYY-MM-DD）は業務日としてそのまま採用。
 * 日時は Asia/Tokyo で日付化する（端末タイムゾーンに依存しない）。
 * @param {string|Date|null|undefined} value
 * @returns {string|null}
 */
export function issueDateKey(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'string') {
    const s = value.trim();
    if (!s) return null;
    const dateOnly = s.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (dateOnly) return dateOnly[1];
  }
  const ymd = formatDateYmdInJst(value);
  return ymd || null;
}

/**
 * 今日（JST）の YYYY-MM-DD。端末のローカル TZ には依存しない。
 * @param {Date} [now]
 */
export function todayDateKey(now = new Date()) {
  return formatDateYmdInJst(now) || null;
}

/**
 * 発行メタの依頼日キー。未発行は null（旧 OK 日は使わない）。
 * @param {object} row
 */
export function issueDateKeyOfRow(row) {
  if (!row) return null;
  return issueDateKey(row.latest_ship_request_issued_at);
}

/**
 * 表示備考に本日発送があり、かつ発行日が今日（JST）。
 * @param {object} row
 * @param {string} [todayYmd]
 */
export function isTodayShipShareRow(row, todayYmd = todayDateKey()) {
  if (!row || !todayYmd) return false;
  if (!bikoContainsTodayShip(row.juchu_biko)) return false;
  const issued = issueDateKeyOfRow(row);
  return issued != null && issued === todayYmd;
}

/**
 * 一覧行の className（本日発送は rose、それ以外は従来どおり）。
 * @param {object} row
 * @param {string} [baseClass]
 * @param {string} [todayYmd]
 */
export function todayShipRowClassName(row, baseClass = 'cursor-pointer', todayYmd = todayDateKey()) {
  if (isTodayShipShareRow(row, todayYmd)) {
    return `bg-rose-50 hover:bg-rose-100 ${baseClass}`.trim();
  }
  return `hover:bg-slate-50 ${baseClass}`.trim();
}
